module.exports = __webpack_public_path__ + "static/media/ALTHAR_LOGO_VERDE_ICONO-07.551f5b06.svg";